<script>
import EventsTable from '@/components/Application/Sales/Events/Table'

export default {
  extends: EventsTable
}
</script>
